import "./Section111ClaimantMatchPicker.scss";

import Table from "components/Table/Table";
import { commonColumnProps } from "constants/TableConstants";
import type { Section111ClaimantMatch } from "services/claims-api";

type Section111ClaimantMatchPickerProps = {
  matches: Section111ClaimantMatch[];
  isFetching: boolean;
  isError: boolean;
  onSelect: (match: Section111ClaimantMatch) => void;
  emptyMessage: string;
};

const maskSsn = (ssn: string | null) => {
  if (!ssn) return "";
  return ssn.length <= 4
    ? "*".repeat(ssn.length)
    : `${"*".repeat(ssn.length - 4)}${ssn.slice(-4)}`;
};

const Section111ClaimantMatchPicker = ({
  matches,
  isFetching,
  isError,
  onSelect,
  emptyMessage,
}: Section111ClaimantMatchPickerProps) => {
  const columns = [
    {
      key: "injured_party_first_name",
      name: "First Name",
      ...commonColumnProps,
    },
    {
      key: "injured_party_last_name",
      name: "Last Name",
      ...commonColumnProps,
    },
    {
      key: "injured_party_ssn",
      name: "SSN",
      ...commonColumnProps,
      renderCell: ({ row }: { row: Section111ClaimantMatch }) =>
        maskSsn(row.injured_party_ssn),
    },
    {
      key: "injured_party_dob",
      name: "DOB",
      ...commonColumnProps,
    },
  ];

  return (
    <div
      className="section-111-claimant-match-picker-scroll"
      onWheel={(e) => {
        e.currentTarget.scrollBy({ top: e.deltaY });
      }}
    >
      <Table<Section111ClaimantMatch>
        className="section-111-claimant-match-picker-table"
        columns={columns}
        rows={isFetching ? [] : matches}
        rowKeyGetter={(row) => row.id}
        onCellClick={({ row }) => onSelect(row)}
        isLoading={isFetching}
        emptyTableMessage={
          isFetching
            ? "Searching..."
            : isError
              ? "Could not load Section 111 matches. Please try again."
              : emptyMessage
        }
      />
    </div>
  );
};

export default Section111ClaimantMatchPicker;
